module.exports = __webpack_public_path__ + "static/media/Icebreakers_Work_Small.72142800.jpg";